import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import starIcon from '@/assets/app/images/icon/icon-star.png';
import starGrayIcon from '@/assets/app/images/icon/icon-star-gray.png';
import TitleHeader from '../common/TitleHeader';
import useAppStore from '@/shared/store/UseAppStore';
import { getUploadsUrl, vAppAjax } from '@/shared/utils/CommonUtil';
import logger from '@/shared/utils/Logger';
import useBottomSheetStore from '@/shared/store/UseBottomSheetStore';
import StripedBgImage from '@/assets/app/images/common/book-icon-bg.png';

interface Props {
  closeFunc: () => void;
  category?: BookEraCategory;
}

const BookPerson: React.FC<Props> = ({ closeFunc, category }) => {
  const [list, setList] = useState<BookPerson[]>([]);
  const { openSheet } = useBottomSheetStore();

  const loadData = async () => {
    await vAppAjax(
      'get',
      `my/book/person`,
      { eraCategoryId: category?.eraCategoryId },
      (response: AxiosResponse<CommonResult>) => {
        const resultData = response.data;
        if (resultData.code === 200) {
          setList(response.data.result);
        } else {
          logger.warn(resultData.message);
        }
      },
      (error: any) => {
        logger.error(error);
      },
    );
  };

  useEffect(() => {
    loadData();
  }, []);

  const completedPerson = category?.completedPerson ?? 0;
  const totalPerson = category?.totalPerson ?? 0;

  const percentage = Math.min(Math.max((completedPerson / totalPerson) * 100, 0), 100); // 60%

  const handlePersonClick = (personInfo: BookPerson) => {
    console.log(category?.themeColor);
    openSheet('person-info', { personInfo, themeColor: category?.themeColor });
    // if (character.unlocked) {
    //   navigate(`/character/${character.id}`);
    // }
  };

  return (
    <div
      className="page-container page-container--white z-[10] w-full h-full bg-[#ffffff]"
      style={{ position: 'fixed', background: 'white', top: 0, left: 0, overflowY: 'auto' }}
    >
      <TitleHeader
        title={category?.categoryName || ''}
        onBack={() => closeFunc()}
        themeColor={category?.themeColor}
      />
      <div
        style={{
          padding: '15px 20px',
        }}
      >
        <div className="book-progress-total relative">
          <div className="book-progress" style={{ width: `${percentage}%` }}></div>
          <div className="book-progress-text-area">
            <span className="book-progress-text">
              {completedPerson}/{totalPerson}
            </span>
          </div>
        </div>
      </div>

      <div
        className="flex"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          columnGap: 4,
          justifyItems: 'center',
          rowGap: 45,
          padding: '15px 20px 120px',
        }}
      >
        {list.map((item, idx) => {
          return (
            <div
              style={{
                position: 'relative',
              }}
              className={`theme-${category?.themeColor}`}
              onClick={() => handlePersonClick(item)}
            >
              <h2 className="absolute left-1/2 -translate-x-1/2 w-full text-center book-profile-title">
                {item?.personName}
              </h2>
              <div className="book-profile-bg">
                <img src={StripedBgImage} alt="Striped Background" className="striped-bg-layer" />
                <div className="book-profile">
                  <img src={`${getUploadsUrl()}/person/${item.imageFilename}`} />{' '}
                </div>
              </div>

              <div className="absolute flex w-full justify-center h-auto" style={{ bottom: -22 }}>
                {[...Array(item.completedChapters)].map((_, index) => (
                  <img src={starIcon} style={{ width: 18, height: 18 }} />
                ))}
                {[...Array(item.totalChapters - (item.completedChapters ?? 0))].map((_, index) => (
                  <img src={starGrayIcon} style={{ width: 18, height: 18 }} />
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BookPerson;
